import React, { useMemo, useState } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export default function FeedbackModal({ open, onClose, context }) {
  const [type, setType] = useState('bug');
  const [message, setMessage] = useState('');
  const [includeContext, setIncludeContext] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const payloadContext = useMemo(() => {
    if (!includeContext) return {};
    return {
      pageUrl: window.location.href,
      city: context?.city || null,
      lat: context?.location?.lat ?? null,
      lng: context?.location?.lng ?? null,
      product: context?.product || null,
      brand: context?.brand || null,
      radiusKm: context?.radius ?? null,
      resultsCount: context?.resultsCount ?? null,
      selectedStationId: context?.selectedStation?.id ?? null,
      selectedStationName: context?.selectedStation?.station_name ?? null,
      userAgent: navigator.userAgent,
    };
  }, [includeContext, context]);

  const reset = () => {
    setType('bug');
    setMessage('');
    setIncludeContext(true);
    setSubmitting(false);
    setSubmitted(false);
    setError('');
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) {
      setError('Escreva uma mensagem.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await axios.post(`${API_BASE}/feedback`, {
        type,
        message: message.trim(),
        ...payloadContext,
      });
      setSubmitted(true);
    } catch {
      setError('Não foi possível enviar seu feedback agora.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!open) return null;

  return (
    <div className="feedback-modal-backdrop" onClick={handleClose}>
      <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
        <div className="feedback-modal-header">
          <h3>Enviar feedback</h3>
          <button className="feedback-close" onClick={handleClose}>×</button>
        </div>

        {submitted ? (
          <div className="feedback-success">
            <p>Obrigado! Seu feedback foi enviado.</p>
            <button className="btn btn-primary" onClick={handleClose}>Fechar</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="feedback-form">
            <div className="feedback-type-group">
              <label>
                <input type="radio" name="feedback-type" value="bug" checked={type === 'bug'} onChange={() => setType('bug')} />
                Reportar bug
              </label>
              <label>
                <input type="radio" name="feedback-type" value="suggestion" checked={type === 'suggestion'} onChange={() => setType('suggestion')} />
                Sugerir melhoria
              </label>
            </div>

            <label className="feedback-label" htmlFor="feedback-message">
              Mensagem
            </label>
            <textarea
              id="feedback-message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={5}
              placeholder={type === 'bug' ? 'Descreva o problema encontrado.' : 'Descreva sua sugestão de melhoria.'}
            />

            <label className="feedback-checkbox">
              <input
                type="checkbox"
                checked={includeContext}
                onChange={(e) => setIncludeContext(e.target.checked)}
              />
              Incluir contexto da busca atual
            </label>

            {includeContext && (
              <div className="feedback-context-preview">
                <div>Cidade: {context?.city || 'Localização atual'}</div>
                <div>Combustível: {context?.product || '-'}</div>
                <div>Bandeira: {context?.brand || 'Todas'}</div>
                <div>Raio: {context?.radius ?? '-'} km</div>
                <div>Resultados: {context?.resultsCount ?? 0}</div>
              </div>
            )}

            {error && <div className="error-banner">{error}</div>}

            <div className="feedback-actions">
              <button type="button" className="btn btn-secondary" onClick={handleClose}>Cancelar</button>
              <button type="submit" className="btn btn-primary" disabled={submitting}>
                {submitting ? 'Enviando...' : 'Enviar'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
